import {
  GET_LIST_DANHSACHKHO,
  GET_LIST_DANHSACHKHO_SUCCESS,
  GET_LIST_DANHSACHKHO_FAILURE,
} from "./actionTypes";

export const getListDanhSachKho = (dataSearch) => ({
  type: GET_LIST_DANHSACHKHO,
  dataSearch,
});

export const getListDanhSachKhoSuccess = (data) => ({
  type: GET_LIST_DANHSACHKHO_SUCCESS,
  payload: data,
});

export const getListDanhSachKhoFailure = () => ({
  type: GET_LIST_DANHSACHKHO_FAILURE,
});
